import React, { useEffect, useState } from "react";
import Access_ControlActions from "../../../Actions/Access_ControlActions";
import Access_ControlConstants from "../../../Constants/Access_ControlConstants";
import access_ControlStore from "../../../Stores/Access_ControlStores";
import { useGlobalSpinnerActionsContext } from "../../../Context/GlobalSpinnerContext";
import { useLanguageContext } from "../../../Context/LanguageContext";
import { useNavigate, useLocation } from "react-router-dom";
import {
  useChildInfoContext,
  useSelectedFunContext,
} from "../../../Context/GlobalContext";
import { GridActionsCellItem } from "@mui/x-data-grid-pro";
import CustomDataGrid from "../../ReusableComponent/DataGrid/CustomizeDataGrid";
import { Typography } from "@mui/material";

function Kinder(props) {
  const setGlobalSpinner = useGlobalSpinnerActionsContext();
  const { localization } = useLanguageContext();
  const location = useLocation();
  const { anlageid, isFunctionCall, handleTourGuid } = props;
  const [childList, setChildList] = useState([]);
  const childObject = useChildInfoContext();
  let navigate = useNavigate();

  const columns = [
    {
      field: "inventarNr",
      headerName: localization.inventanrnr,
      hideable: false,
      flex: 1,
    },
    {
      field: "actions",
      type: "actions",
      //width: 45,
      hideable: false,
      headerName: localization.actions,
      getActions: (params) => [...getAction(params, localization)],
    },
    // {
    //   field: "name",
    //   headerName: localization.name,
    //   hideable: false,
    //   flex: 1,
    // },
    {
      field: "tag",
      headerName: localization.tag,
      hideable: false,
      flex: 1,
    },
  ];

  function getAction(params) {
    const _acionList = [];
    _acionList.push(
      <GridActionsCellItem
        label={localization.viewDetail}
        showInMenu
        onClick={() => {
          handleRowClick(params.row);
        }}
      />,
    );
    return _acionList;
  }

  const getchildren = () => {
    setGlobalSpinner(true);
    Access_ControlActions.gatAnlageChildren(anlageid);
  };
  useEffect(() => {
    if (props) {
      getchildren();
    }
    return () => {};
  }, [props]);

  useEffect(() => {
    function getChildByParentIDSuccess() {
      const res = access_ControlStore.getAnlageChild();
      if (res.length > 0) {
        setChildList(res);
      } else {
        setChildList([]);
      }
      handleTourGuid(6);
      setGlobalSpinner(false);
    }

    function getChildByParentIDSuccessFailure() {
      const res = access_ControlStore.getAnlageChild();
      setGlobalSpinner(false);
    }

    access_ControlStore.addChangeListener(
      Access_ControlConstants.GET_ANLAGE_CHILDREN_SUCCESS,
      getChildByParentIDSuccess,
    );

    access_ControlStore.addChangeListener(
      Access_ControlConstants.GET_ANLAGE_CHILDREN_FAILURE,
      getChildByParentIDSuccessFailure,
    );

    return () => {
      access_ControlStore.removeChangeListener(
        Access_ControlConstants.GET_ANLAGE_CHILDREN_SUCCESS,
        getChildByParentIDSuccess,
      );

      access_ControlStore.removeChangeListener(
        Access_ControlConstants.GET_ANLAGE_CHILDREN_FAILURE,
        getChildByParentIDSuccessFailure,
      );
    };
  }, []);
  function renderRootPath() {
    const _parentPath = location.pathname.startsWith("/equipmentGrpEqiupment")
      ? "/equipmentGrpEqiupment"
      : "/inspection";
    return _parentPath;
  }
  function handleRowClick(row) {
    let path = "";
    const _rootPath = renderRootPath();
    props.handleTabSelection(1);
    sessionStorage.setItem("eqId", row.id);
    sessionStorage.setItem("invnr", row.inventarNr);
    const equiBez = row.name;
    const rowbez =
      equiBez !== null && equiBez !== undefined && equiBez.length != 0
        ? row.name
        : "-";
    if (!isFunctionCall) {
      path =
        _rootPath +
        "/" +
        sessionStorage.getItem("eqBez") +
        "/" +
        childObject[childObject.length - 1].equipId +
        "/" +
        childObject[childObject.length - 1].bezeichnung +
        "/" +
        childObject[childObject.length - 1].inventarnr +
        "/" +
        row.id +
        "/" +
        rowbez +
        "/" +
        row.inventarNr;
    } else {
      path =
        _rootPath +
        "/" +
        sessionStorage.getItem("eqBez") +
        "/" +
        childObject[0].funcId +
        "/" +
        childObject[0].funcName +
        "/" +
        childObject[childObject.length - 1].equipId +
        "/" +
        childObject[childObject.length - 1].bezeichnung +
        "/" +
        childObject[childObject.length - 1].inventarnr +
        "/" +
        row.id +
        "/" +
        rowbez +
        "/" +
        row.inventarNr;
    }
    navigate(path);
  }

  return (
    <>
      <div className="container-fluid equipDetailContainer p-5 mt-3">
        <div className="row justifyContentSpaceBetw">
          <div className="">
            <Typography gutterBottom variant="h4" component="div">
              {localization.children}
            </Typography>
            <Typography variant="body2" sx={{ color: "text.secondary" }}>
              {localization.childrenDescriptionInfo}
            </Typography>
          </div>
        </div>
        <div className="childrenList mt-4">
          {childList && (
            <CustomDataGrid
              columns={columns}
              rows={childList}
              operations={{}}
              onAdd={{}}
              showExport={true}
              showColumns={true}
              showFilters={true}
              showDensity={true}
              visibleColumns={[]}
              showCheckBox={false}
              gridTableHeight={"dataGridChildren"}
            />
          )}
        </div>
      </div>
    </>
  );
}
export default Kinder;
